/* eslint-disable react/require-default-props */
import { attributesToProps, domToReact } from 'html-react-parser';
import PropTypes from 'prop-types';
import React from 'react';
import AccountsList from '../../../../../components/Molecules/AccountsList';
import { findDomElementFilterFn } from '../../../../findDomElement';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';
import { wpClassNames } from './Constants';

const filterFn = (className) => (element) => element.attribs?.class?.includes(className);
const extractAccountItem = ( node, replaceFn, index ) =>
{
    const accountItem = { id: `parsed-account-item-${index}`, icon: null, title: null, subTitle: null };
    const titleContainer = findDomElementFilterFn({ element: node, filterFn: filterFn(wpClassNames.BLOCK_ITEM_TITLE) });
    if ( titleContainer )
    {
        accountItem.title = titleContainer?.children ? domToReact( titleContainer.children, replaceFn()) : null;
    }

    const subTitleContainer = findDomElementFilterFn({ element: node, filterFn: filterFn(wpClassNames.BLOCK_ITEM_SUBTITLE) });
    if ( subTitleContainer )
    {
        accountItem.subTitle = subTitleContainer?.children ? domToReact( subTitleContainer.children, replaceFn()) : null
    }

    const svgContainer = findDomElementFilterFn({ element: node, filterFn: filterFn(wpClassNames.BLOCK_ITEM_ICON_CONTAINER) });
    if ( svgContainer )
    {
        accountItem.icon = (svgContainer?.children?.length) ? domToReact(svgContainer?.children, replaceFn()) : null;
    }

    return {...accountItem};
}
export const extractAccounts = ( children, replaceFn ) =>
{
    const accountItems = children?.filter( child => child.type === 'tag' && child.name === 'div' && child?.attribs?.class.includes(wpClassNames.BLOCK_ITEM_CONTAINER));

    if (accountItems?.length === 0) return [];

    return [...accountItems.map( (accountItem, index) => ({...extractAccountItem( accountItem, replaceFn, index )} ))] || [];
}
const AccountsComponent = ({ childEls, replaceFn, ...props }) => (<AccountsList accounts={extractAccounts( childEls, replaceFn )} {...props} />);
AccountsComponent.propTypes = {
    /** childEls: The children elements of the AccountsList */
    childEls: PropTypes.array,
    /** replaceFn: The replacement function */
    replaceFn: PropTypes.func
}

const toAccountsList = (parserData) =>
{
    const { parserOptions: {replaceFn} } = parserData
    const Wrapper = ({
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type,
        attribs = parserPropTypesDefaults.attribs,
        children = parserPropTypesDefaults.children
    }) =>
    {
        if ( type !== 'tag' ) return null;
        if ( !name || name !== 'div' ) return null;
        if (!attribs?.class || !attribs?.class.includes(wpClassNames.BLOCK_CONTAINER)) return null;
        if (!children || !Array.isArray(children)) return null;
        if (children.length === 0) return null;

        const props = attributesToProps(attribs);

        return <AccountsComponent childEls={children} replaceFn={replaceFn} {...props} />;
    }
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
}

export default toAccountsList;